import { FC, useState } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useForm, Controller } from 'react-hook-form';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery, useMutation } from 'react-query';
import { Grid, Input, IconButton, InputAdornment, FormControl, InputLabel } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import { observer } from 'mobx-react-lite';
import { EndUserPasswordInfo } from 'domain/user/types';
export const EndUserPasswordForm: FC = observer(() => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showoldPassword, setShowOldPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const {
    userStore: { updateEndUserPasswordInfo },
    endUserSettingsFormStore: { getPortalSettings },
    notificationStore: { openNotification },
  } = useStore();
  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  const updateUserProfileInfoReq = useMutation((data: EndUserPasswordInfo) => updateEndUserPasswordInfo(data), {
    onSuccess: () => {
      openNotification('success', 'Password updated successfully.');
      reset({
        current_password: '',
        password: '',
        password_confirmation: '',
      });
    },
    onError: (error: unknown) => {
      let errorMessage = 'An error occurred while updating your profile.';
      if (typeof error === 'object' && error !== null && 'message' in error) {
        errorMessage = (error as { message: string }).message;
      }
      openNotification('error', errorMessage);
    },
  });
  useAppPreloader(portalSettingsgetReq.isFetching);

  const { control, handleSubmit, reset } = useForm<EndUserPasswordInfo>();
  const onSubmit = (data: EndUserPasswordInfo) => {
    return updateUserProfileInfoReq.mutate(data);
  };

  return (
    <>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid className={classes.btnContainer}>
          <Button className={classes.btn} type='submit' variant='contained'>
            Save Changes
          </Button>
        </Grid>
        <div className={classes.formContainer}>
          <div className={classes.rightCol}>
            <div className={classes.heading}>Change Password</div>
            <Grid container justify='space-between' className={classes.container}>
              <Grid className={classes.block} container>
                <Controller
                  name='current_password'
                  control={control}
                  rules={{ required: false }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid className={classes.row} container>
                      <FormControl className={classes.input}>
                        <InputLabel htmlFor='password'>Current Password</InputLabel>
                        <Input
                          {...field}
                          id='current_password'
                          name='current_password'
                          onChange={field.onChange}
                          error={invalid}
                          type={showoldPassword ? 'text' : 'password'}
                          endAdornment={
                            <InputAdornment position='end'>
                              <IconButton
                                aria-label='toggle password visibility'
                                onClick={() => setShowOldPassword(!showoldPassword)}
                              >
                                {showoldPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                          key='current_password'
                          placeholder='Enter Current Password'
                        />
                      </FormControl>
                    </Grid>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container justify='space-between' className={classes.container}>
              <Grid className={classes.block} container>
                <Controller
                  name='password'
                  control={control}
                  rules={{ required: false }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid className={classes.row} container>
                      <FormControl className={classes.input}>
                        <InputLabel htmlFor='password'>New Password</InputLabel>
                        <Input
                          {...field}
                          id='password'
                          name='password'
                          onChange={field.onChange}
                          error={invalid}
                          type={showPassword ? 'text' : 'password'}
                          endAdornment={
                            <InputAdornment position='end'>
                              <IconButton
                                aria-label='toggle password visibility'
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                          key='password'
                          placeholder='Enter New Password'
                        />
                      </FormControl>
                    </Grid>
                  )}
                />
                <Controller
                  name='password_confirmation'
                  control={control}
                  rules={{ required: false }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid className={classes.row} container>
                      <FormControl className={classes.input}>
                        <InputLabel htmlFor='confirmpassword'>Confirm New Password</InputLabel>
                        <Input
                          id='confirmpassword'
                          {...field}
                          onChange={field.onChange}
                          error={invalid}
                          type={showConfirmPassword ? 'text' : 'password'}
                          key='confirmpassword'
                          endAdornment={
                            <InputAdornment position='end'>
                              <IconButton
                                aria-label='toggle password visibility'
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              >
                                {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                          placeholder='Confirm New Password'
                        />
                      </FormControl>
                    </Grid>
                  )}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    </>
  );
});
